import { Nullable } from "./nullable";

interface Translator {
  translate(key: string, params?: Record<string, any>): string;
}

let translatorInstance: Nullable<Translator> = null;

export function setTranslator(translator: Translator): void {
  translatorInstance = translator;
}

export function translate(key: string, params?: Record<string, any>): string {
  return translatorInstance?.translate(key, params) ?? "";
}

export function sntTranslate(
  key: string,
  params?: Record<string, any>
): string {
  return translate(key, params);
}
